module.exports = __webpack_public_path__ + "img/sign_220150555_1.e7f549c7.png";